import { queryBuilder } from '@/common/utils/query.util';

export const PROMETHEUS_API_URL = '/prometheus/api/v1';
export const PROMETHEUS_TICK_NUMBER = 300;
export const POLLING_QUERY_INTERVAL = 30000;
export const DEFAULT_START = 'now-12h';
export const DEFAULT_END = 'now';

export const OVERVIEW_DISK_READ = 'sum(instance_device:node_disk_read_bytes:rate5m and on (node, device) cluster_csd_disk_info)';
export const OVERVIEW_DISK_READ_IOPS = 'sum(instance_device:node_disk_reads_completed:rate5m and on (node, device) cluster_csd_disk_info)';
export const OVERVIEW_DISK_WRITE = 'sum(instance_device:node_disk_written_bytes:rate5m and on (node, device) cluster_csd_disk_info)';
export const OVERVIEW_DISK_WRITE_IOPS = 'sum(instance_device:node_disk_writes_completed:rate5m and on (node, device) cluster_csd_disk_info)';
export const OVERVIEW_CS_STATUSES = 'sum by (status) (master:mdsd_cs_status)';
export const OVERVIEW_MDS_FAILED = 'job:up:count{job="mds"}-job:up:sum{job="mds"}';
export const OVERVIEW_MDS_ONLINE = 'job:up:sum{job="mds"}';

// available params: node, device
export const NODE_CPU_USAGE = params => queryBuilder`instance:node_cpu_seconds:rate5m{${params}} * 100`;
export const NODE_MEM_USAGE = params => queryBuilder`node_memory_MemTotal_bytes{${params}} - node_memory_MemAvailable_bytes{${params}}`;
export const NODE_DISKS_READ = params => queryBuilder`sum(instance_device:node_disk_read_bytes:rate5m{${params}})`;
export const NODE_DISKS_READ_IOPS = params => queryBuilder`sum(instance_device:node_disk_reads_completed:rate5m{${params}})`;
export const NODE_DISKS_WRITE = params => queryBuilder`sum(instance_device:node_disk_written_bytes:rate5m{${params}})`;
export const NODE_DISKS_WRITE_IOPS = params => queryBuilder`sum(instance_device:node_disk_writes_completed:rate5m{${params}})`;
export const NODE_NETWORK_RECEIVE = params => queryBuilder`sum(instance_device:node_network_receive_bytes:rate5m{${params}})`;
export const NODE_NETWORK_TRANSMIT = params => queryBuilder`sum(instance_device:node_network_transmit_bytes:rate5m{${params}})`;
export const NODE_NETWORK_RECEIVE_ERRORS = params => queryBuilder`sum(instance_device:node_network_receive_drop:rate5m{${params}}) + sum(instance_device:node_network_receive_errs:rate5m{${params}}) + sum(instance_device:node_network_receive_fifo:rate5m{${params}})`;
export const NODE_NETWORK_TRANSMIT_ERRORS = params => queryBuilder`sum(instance_device:node_network_transmit_drop:rate5m{${params}}) + sum(instance_device:node_network_transmit_errs:rate5m{${params}}) + sum(instance_device:node_network_transmit_fifo:rate5m{${params}})`;

export const NODE_INTERFACE_RX = params => queryBuilder`instance_device:node_network_receive_bytes:rate5m{${params}}`;
export const NODE_INTERFACE_TX = params => queryBuilder`instance_device:node_network_transmit_bytes:rate5m{${params}}`;
export const NODE_INTERFACE_RX_ERRORS = params => queryBuilder`instance_device:node_network_receive_drop:rate5m{${params}} + instance_device:node_network_receive_errs:rate5m{${params}} + instance_device:node_network_receive_fifo:rate5m{${params}}`;
export const NODE_INTERFACE_TX_ERRORS = params => queryBuilder`instance_device:node_network_transmit_drop:rate5m{${params}} + instance_device:node_network_transmit_errs:rate5m{${params}} + instance_device:node_network_transmit_fifo:rate5m{${params}}`;
export const NODE_INTERFACE_RX_PACKAGES = params => queryBuilder`instance_device:node_network_receive_packets:rate5m{${params}}`;
export const NODE_INTERFACE_TX_PACKAGES = params => queryBuilder`instance_device:node_network_transmit_packets:rate5m{${params}}`;

export const NODE_DISK_READ_LATENCY = params => queryBuilder`instance_device:node_disk_read_time_seconds:rate5m{${params}} / instance_device:node_disk_reads_completed:rate5m{${params}}`;
export const NODE_DISK_WRITE_LATENCY = params => queryBuilder`instance_device:node_disk_write_time_seconds:rate5m{${params}} / instance_device:node_disk_writes_completed:rate5m{${params}}`;
export const NODE_DISK_READ_BANDWIDTH = params => queryBuilder`instance_device:node_disk_read_bytes:rate5m{${params}}`;
export const NODE_DISK_WRITE_BANDWIDTH = params => queryBuilder`instance_device:node_disk_written_bytes:rate5m{${params}}`;
export const NODE_DISK_READ_IOPS = params => queryBuilder`instance_device:node_disk_reads_completed:rate5m{${params}}`;
export const NODE_DISK_WRITE_IOPS = params => queryBuilder`instance_device:node_disk_writes_completed:rate5m{${params}}`;

export const ABGW_FAILED_NODES = 'job:up:count{job="abgw"} - job:up_with_restart:sum{job="abgw"}';
export const ABGW_ONLINE_NODES = 'job:up_with_restart:sum{job="abgw"}';
export const ABGW_READ = 'job:abgw_read_bytes:rate5m';
export const ABGW_WRITE = 'job:abgw_write_bytes:rate5m';
export const ABGW_REPLICA_BACKLOG = 'type:abgw_push_backlog_bytes:sum{type="replica"}';
export const ABGW_REPLICA_SPEED = 'type:abgw_push_progress_bytes:rate5m{type="replica"}';
export const ABGW_OSTOR_BACKLOG = 'type:abgw_push_backlog_bytes:sum{type="ostor"}';
export const ABGW_OSTOR_SPEED = 'type:abgw_push_progress_bytes:rate5m{type="ostor"}';
export const ABGW_LATENCY_95 = 'histogram_quantile(0.95, req_le:abgw_req_latency_ms_bucket:rate5m{req="Append"}) / 1000';
export const ABGW_LATENCY_99 = 'histogram_quantile(0.99, req_le:abgw_req_latency_ms_bucket:rate5m{req="Append"}) / 1000';
export const ABGW_LATENCY_100 = 'histogram_quantile(1, req_le:abgw_req_latency_ms_bucket:rate5m{req="Append"}) / 1000';
export const ABGW_LATENCY_AVG = 'req:abgw_req_latency_ms_sum:rate5m{req="Append"}/req:abgw_req_latency_ms_count:rate5m{req="Append"} / 1000';
export const ABGW_THROTTLE = 'job:abgw_append_throttle_delay_ms:rate5m / job:abgw_write_reqs:rate5m / 1000';

export const ABGW_NODE_CPU_USAGE = params => queryBuilder`sum(instance_mode:process_cpu_seconds:rate5m{${params}}) * 100`;
export const ABGW_NODE_MEM_USAGE = params => queryBuilder`process_resident_memory_bytes{${params}}`;
export const ABGW_NODE_SUCCESS_RATE = params => queryBuilder`sum(instance_req_err:abgw_req_errs:rate5m{err="OK", ${params}})`;
export const ABGW_NODE_FAILED_RATE = params => queryBuilder`sum(instance_req_err:abgw_req_errs:rate5m{err!="OK", ${params}})`;
export const ABGW_NODE_NETWORK_READ = params => queryBuilder`sum(instance_proxied:abgw_read_bytes:rate5m{${params}})`;
export const ABGW_NODE_NETWORK_WRITE = params => queryBuilder`sum(instance_proxied:abgw_write_bytes:rate5m{${params}})`;
export const ABGW_NODE_NETWORK_READ_IOPS = params => queryBuilder`sum(instance:abgw_read_reqs:rate5m{${params}})`;
export const ABGW_NODE_NETWORK_WRITE_IOPS = params => queryBuilder`sum(instance:abgw_write_reqs:rate5m{${params}})`;
export const ABGW_NODE_LATENCY_95 = params => queryBuilder`histogram_quantile(0.95, instance_req_le:abgw_req_latency_ms_bucket:rate5m{req="Append", ${params}})`;
export const ABGW_NODE_LATENCY_99 = params => queryBuilder`histogram_quantile(0.99, instance_req_le:abgw_req_latency_ms_bucket:rate5m{req="Append", ${params}})`;
export const ABGW_NODE_LATENCY_100 = params => queryBuilder`histogram_quantile(1, instance_req_le:abgw_req_latency_ms_bucket:rate5m{req="Append", ${params}})`;
export const ABGW_NODE_LATENCY_AVG = params => queryBuilder`instance_req:abgw_req_latency_ms_sum:rate5m{req="Append", ${params}}/instance_req:abgw_req_latency_ms_count:rate5m{req="Append", ${params}}`;

export const S3_NODE_CPU_USAGE = params => queryBuilder`sum(instance_mode:process_cpu_seconds:rate5m{${params}}) * 100`;
export const S3_NODE_MEM_USAGE = params => queryBuilder`process_resident_memory_bytes{${params}}`;
export const S3_NODE_SUCCESS_RATE = params => queryBuilder`sum(instance_req_err:ostor_s3gw_req_errs:rate5m{err="OK", ${params}})`;
export const S3_NODE_FAILED_RATE = params => queryBuilder`sum(instance_req_err:ostor_s3gw_req_errs:rate5m{err!="OK", ${params}})`;
export const S3_NODE_NETWORK_READ = params => queryBuilder`sum(instance_proxied:ostor_s3gw_read_bytes:rate5m{${params}})`;
export const S3_NODE_NETWORK_WRITE = params => queryBuilder`sum(instance_proxied:ostor_s3gw_write_bytes:rate5m{${params}})`;
export const S3_NODE_NETWORK_READ_IOPS = params => queryBuilder`sum(instance:ostor_s3gw_read_reqs:rate5m{${params}})`;
export const S3_NODE_NETWORK_WRITE_IOPS = params => queryBuilder`sum(instance:ostor_s3gw_write_reqs:rate5m{${params}})`;
export const S3_NODE_LATENCY_95 = params => queryBuilder`histogram_quantile(0.95, instance_req_le:ostor_s3gw_req_latency_ms_bucket:rate5m{req="Append", ${params}})`;
export const S3_NODE_LATENCY_99 = params => queryBuilder`histogram_quantile(0.99, instance_req_le:ostor_s3gw_req_latency_ms_bucket:rate5m{req="Append", ${params}})`;
export const S3_NODE_LATENCY_100 = params => queryBuilder`histogram_quantile(1, instance_req_le:ostor_s3gw_req_latency_ms_bucket:rate5m{req="Append", ${params}})`;
export const S3_NODE_LATENCY_AVG = params => queryBuilder`instance_req:ostor_s3gw_req_latency_ms_sum:rate5m{req="Append", ${params}}/instance_req:abgw_req_latency_ms_count:rate5m{req="Append", ${params}}`;

// available params: domain_uuid
export const COMPUTE_CPU_USAGE = params => queryBuilder`sum(rate(libvirt_domain_info_cpu_time_seconds_total{${params}}[5m])) / sum(libvirt_domain_info_virtual_cpus{${params}}) * 100`;
export const COMPUTE_MEM_USAGE = params => queryBuilder`sum(libvirt_domain_info_process_rss{${params}})`;
export const COMPUTE_DISK_READ = params => queryBuilder`rate(libvirt_domain_block_stats_read_bytes_total{${params}}[5m])`;
export const COMPUTE_DISK_WRITE = params => queryBuilder`rate(libvirt_domain_block_stats_write_bytes_total{${params}}[5m])`;
export const COMPUTE_DISK_READ_IOPS = params => queryBuilder`rate(libvirt_domain_block_stats_read_requests_total{${params}}[5m])`;
export const COMPUTE_DISK_WRITE_IOPS = params => queryBuilder`rate(libvirt_domain_block_stats_write_requests_total{${params}}[5m])`;
export const COMPUTE_DISK_READ_LATENCY_95 = params => queryBuilder`
histogram_quantile(
  0.95,
  rate(libvirt_domain_block_stats_read_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_READ_LATENCY_99 = params => queryBuilder`
histogram_quantile(
  0.99,
  rate(libvirt_domain_block_stats_read_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_READ_LATENCY_100 = params => queryBuilder`
histogram_quantile(
  1,
  rate(libvirt_domain_block_stats_read_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_READ_LATENCY_AVG = params => queryBuilder`rate(libvirt_domain_block_stats_read_latency_ms_sum{${params}}[5m])/rate(libvirt_domain_block_stats_read_latency_ms_count{${params}}[5m]) / 1000`;
export const COMPUTE_DISK_WRITE_LATENCY_95 = params => queryBuilder`
histogram_quantile(
  0.95,
  rate(libvirt_domain_block_stats_write_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_WRITE_LATENCY_99 = params => queryBuilder`
histogram_quantile(
  0.99,
  rate(libvirt_domain_block_stats_write_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_WRITE_LATENCY_100 = params => queryBuilder`
histogram_quantile(
  1,
  rate(libvirt_domain_block_stats_write_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_WRITE_LATENCY_AVG = params => queryBuilder`rate(libvirt_domain_block_stats_write_latency_ms_sum{${params}}[5m])/rate(libvirt_domain_block_stats_write_latency_ms_count{${params}}[5m]) / 1000`;
export const COMPUTE_DISK_FLUSH_LATENCY_95 = params => queryBuilder`
histogram_quantile(
  0.95,
  rate(libvirt_domain_block_stats_flush_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_FLUSH_LATENCY_99 = params => queryBuilder`
histogram_quantile(
  0.99,
  rate(libvirt_domain_block_stats_flush_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_FLUSH_LATENCY_100 = params => queryBuilder`
histogram_quantile(
  1,
  rate(libvirt_domain_block_stats_flush_latency_ms_bucket{${params}}[5m])
) / 1000`;
export const COMPUTE_DISK_FLUSH_LATENCY_AVG = params => queryBuilder`rate(libvirt_domain_block_stats_flush_latency_ms_sum{${params}}[5m])/rate(libvirt_domain_block_stats_flush_latency_ms_count{${params}}[5m]) / 1000`;
export const COMPUTE_NETWORK_RECEIVE = params => queryBuilder`rate(libvirt_domain_interface_stats_receive_bytes_total{${params}}[5m])`;
export const COMPUTE_NETWORK_TRANSMIT = params => queryBuilder`rate(libvirt_domain_interface_stats_transmit_bytes_total{${params}}[5m])`;
export const COMPUTE_NETWORK_RECEIVE_PACKETS = params => queryBuilder`rate(libvirt_domain_interface_stats_receive_bytes_total{${params}}[5m])`;
export const COMPUTE_NETWORK_TRANSMIT_PACKETS = params => queryBuilder`rate(libvirt_domain_interface_stats_transmit_bytes_total{${params}}[5m])`;
export const COMPUTE_NETWORK_RECEIVE_DROPS = params => queryBuilder`rate(libvirt_domain_interface_stats_receive_drops_total{${params}}[5m])`;
export const COMPUTE_NETWORK_TRANSMIT_DROPS = params => queryBuilder`rate(libvirt_domain_interface_stats_transmit_drops_total{${params}}[5m])`;

export const S3_ACC_ONLINE = 'sum(up{job="acc"})';
export const S3_NS_ONLINE = 'sum(up{job="ns"})';
export const S3_OS_ONLINE = 'sum(up{job="os", vol_id=~"01.*"})';
export const S3_GW_ONLINE = 'sum(up{job="s3gw"})';
export const S3_ACC_FAILURE = 'count(up{job="acc"}) - sum(up{job="acc"})';
export const S3_NS_FAILURE = 'count(up{job="ns"}) - sum(up{job="ns"})';
export const S3_OS_FAILURE = 'count(up{job="os", vol_id=~"01.*"}) - sum(up{job="os", vol_id=~"01.*"})';
export const S3_GW_FAILURE = 'count(up{job="s3gw"}) - sum(up{job="s3gw"})';

export const S3_RATE_PUT = 'sum(instance_vol_svc:ostor_s3gw_put_req:rate5m{job="s3gw"})';
export const S3_RATE_GET = 'sum(instance_vol_svc:ostor_s3gw_get_req:rate5m{job="s3gw"})';
export const S3_RATE_LIST = 'sum(instance_vol_svc:ostor_s3gw_list_req:rate5m{job="s3gw"})';
export const S3_RATE_DELETE = 'sum(instance_vol_svc:ostor_s3gw_delete_req:rate5m{job="s3gw"})';
export const S3_RATE_FAILURE = 'sum(instance_vol_svc:ostor_s3gw_req_failed:rate5m{job="s3gw"}) + sum(instance_vol_svc:ostor_s3gw_req_cancelled:rate5m{job="s3gw"})';
export const S3_INGRESS = 'sum(instance_vol_svc:ostor_s3gw_fcgi_read_size:rate5m{job="s3gw"})';
export const S3_EGRESS = 'sum(instance_vol_svc:ostor_s3gw_fcgi_write_size:rate5m{job="s3gw"})';

export const S3_PUT_LATENCY_LATENCY_95 = 'histogram_quantile(0.95, sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_bucket:rate5m{job="s3gw"}) by (le)) / 1000';
export const S3_PUT_LATENCY_LATENCY_99 = 'histogram_quantile(0.99, sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_bucket:rate5m{job="s3gw"}) by (le)) / 1000';
export const S3_PUT_LATENCY_LATENCY_100 = 'histogram_quantile(1, sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_bucket:rate5m{job="s3gw"}) by (le)) / 1000';
export const S3_PUT_LATENCY_AVG = 'sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_sum:rate5m{job="s3gw"})/sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_count:rate5m{job="s3gw"}) / 1000';

export const S3_GET_LATENCY_LATENCY_95 = 'histogram_quantile(0.95, sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_bucket:rate5m{job="s3gw"}) by (le)) / 1000';
export const S3_GET_LATENCY_LATENCY_99 = 'histogram_quantile(0.99, sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_bucket:rate5m{job="s3gw"}) by (le)) / 1000';
export const S3_GET_LATENCY_LATENCY_100 = 'histogram_quantile(1, sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_bucket:rate5m{job="s3gw"}) by (le)) / 1000';
export const S3_GET_LATENCY_AVG = 'sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_sum:rate5m{job="s3gw"})/sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_count:rate5m{job="s3gw"}) / 1000';

export const S3_NODE_PUT_LATENCY_LATENCY_95 = params => queryBuilder`histogram_quantile(0.95, sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_bucket:rate5m{${params}}) by (le)) / 1000`;
export const S3_NODE_PUT_LATENCY_LATENCY_99 = params => queryBuilder`histogram_quantile(0.99, sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_bucket:rate5m{${params}}) by (le)) / 1000`;
export const S3_NODE_PUT_LATENCY_LATENCY_100 = params => queryBuilder`histogram_quantile(1, sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_bucket:rate5m{${params}}) by (le)) / 1000`;
export const S3_NODE_PUT_LATENCY_AVG = params => queryBuilder`sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_sum:rate5m{${params}}) by (le)/sum(instance_vol_svc:ostor_s3gw_put_req_latency_ms_count:rate5m{${params}}) by (le) / 1000`;

export const S3_NODE_GET_LATENCY_LATENCY_95 = params => queryBuilder`histogram_quantile(0.95, sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_bucket:rate5m{${params}}) by (le)) / 1000`;
export const S3_NODE_GET_LATENCY_LATENCY_99 = params => queryBuilder`histogram_quantile(0.99, sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_bucket:rate5m{${params}}) by (le)) / 1000`;
export const S3_NODE_GET_LATENCY_LATENCY_100 = params => queryBuilder`histogram_quantile(1, sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_bucket:rate5m{${params}}) by (le)) / 1000`;
export const S3_NODE_GET_LATENCY_AVG = params => queryBuilder`sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_sum:rate5m{${params}}) by (le)/sum(instance_vol_svc:ostor_s3gw_get_req_latency_ms_count:rate5m{${params}}) by (le) / 1000`;

export const ISCSI_DISK_READ = params => queryBuilder`sum(instance_group_target_ini:iscsi_read_kbytes:rate5m{${params}}) * 1000`;
export const ISCSI_DISK_WRITE = params => queryBuilder`sum(instance_group_target_ini:iscsi_write_kbytes:rate5m{${params}}) * 1000`;
export const ISCSI_DISK_READ_IOPS = params => queryBuilder`sum(instance_group_target_ini:iscsi_read_cmds:rate5m{${params}})`;
export const ISCSI_DISK_WRITE_IOPS = params => queryBuilder`sum(instance_group_target_ini:iscsi_write_cmds:rate5m{${params}})`;

export const ISCSI_DISK_READ_LATENCY_95 = params => queryBuilder`histogram_quantile(0.95, sum(instance_group_target_lunno_le:iscsi_read_latency_us_bucket:rate5m{${params}}) by (le) ) / 1000000`;
export const ISCSI_DISK_READ_LATENCY_99 = params => queryBuilder`histogram_quantile(0.99, sum(instance_group_target_lunno_le:iscsi_read_latency_us_bucket:rate5m{${params}}) by (le) ) / 1000000`;
export const ISCSI_DISK_READ_LATENCY_100 = params => queryBuilder`histogram_quantile(1.00, sum(instance_group_target_lunno_le:iscsi_read_latency_us_bucket:rate5m{${params}}) by (le) ) / 1000000`;
export const ISCSI_DISK_READ_LATENCY_AVG = params => queryBuilder`sum(instance_group_target_lunno:iscsi_read_latency_us_sum:rate5m{${params}}) by (le)/sum(instance_group_target_lunno:iscsi_read_latency_us_count:rate5m{${params}}) by (le)  / 1000000`;

export const ISCSI_DISK_WRITE_LATENCY_95 = params => queryBuilder`histogram_quantile(0.95, sum(instance_group_target_lunno_le:iscsi_write_latency_us_bucket:rate5m{${params}}) by (le)) / 1000000`;
export const ISCSI_DISK_WRITE_LATENCY_99 = params => queryBuilder`histogram_quantile(0.99, sum(instance_group_target_lunno_le:iscsi_write_latency_us_bucket:rate5m{${params}}) by (le)) / 1000000`;
export const ISCSI_DISK_WRITE_LATENCY_100 = params => queryBuilder`histogram_quantile(1, sum(instance_group_target_lunno_le:iscsi_write_latency_us_bucket:rate5m{${params}}) by (le)) / 1000000`;
export const ISCSI_DISK_WRITE_LATENCY_AVG = params => queryBuilder`sum(instance_group_target_lunno:iscsi_write_latency_us_sum:rate5m{${params}}) by (le)/sum(instance_group_target_lunno:iscsi_write_latency_us_count:rate5m{${params}}) by (le) / 1000000`;

export const LBAAS_LOAD_BALANCER_CPU = params => queryBuilder`sum(rate(libvirt_domain_info_cpu_time_seconds_total{${params}}[5m])) * 100`;
export const LBAAS_LOAD_BALANCER_RAM = params => queryBuilder`sum(libvirt_domain_info_process_rss{${params}})`;
export const LBAAS_LOAD_BALANCER_NETWORK_RECEIVE = params => queryBuilder`rate(lbaas_loadbalancer_bytes_in{${params}}[5m])`; // bytes_in as total_bytes_in
export const LBAAS_LOAD_BALANCER_NETWORK_TRANSMIT = params => queryBuilder`rate(lbaas_loadbalancer_bytes_out{${params}}[5m])`; // bytes_out as total_bytes_out
export const LBAAS_LOAD_BALANCER_REQUEST_ERRORS = params => queryBuilder`rate(lbaas_loadbalancer_request_errors{${params}}[5m])`;
export const LBAAS_LOAD_BALANCER_ACTIVE_CONNECTIONS = params => queryBuilder`lbaas_loadbalancer_active_connections{${params}}`;

export const LBAAS_BALANCER_POOL_NETWORK_RECEIVE = params => queryBuilder`rate(lbaas_pool_bytes_in{${params}}[5m])`; // bytes_in as total_bytes_in
export const LBAAS_BALANCER_POOL_NETWORK_TRANSMIT = params => queryBuilder`rate(lbaas_pool_bytes_out{${params}}[5m])`; // bytes_out as total_bytes_out
export const LBAAS_BALANCER_POOL_ACTIVE_CONNECTIONS = params => queryBuilder`lbaas_pool_active_connections{${params}}`;
export const LBAAS_BALANCER_POOL_REQUEST_ERRORS = params => queryBuilder`rate(lbaas_pool_request_errors{${params}}[5m])`;

export const LBAAS_BALANCER_POOL_MEMBER_NETWORK_RECEIVE = params => queryBuilder`rate(lbaas_member_bytes_in{${params}}[5m])`;
export const LBAAS_BALANCER_POOL_MEMBER_NETWORK_TRANSMIT = params => queryBuilder`rate(lbaas_member_bytes_out{${params}}[5m])`;
export const LBAAS_BALANCER_POOL_MEMBER_ACTIVE_CONNECTIONS = params => queryBuilder`lbaas_member_active_connections{${params}}`;
export const LBAAS_BALANCER_POOL_MEMBER_REQUEST_ERRORS = params => queryBuilder`rate(lbaas_member_request_errors{${params}}[5m])`;

export const MPFS_TOTAL_SAMBA_ONLINE = 'sum(up{job=~"mpfs_samba"})';
export const MPFS_TOTAL_MDS_ONLINE = 'sum(up{job=~"mpfs_mds"})';
export const MPFS_TOTAL_DS_ONLINE = 'sum(up{job=~"mpfs_ds"})';
export const MPFS_TOTAL_LS_ONLINE = 'sum(up{job=~"mpfs_ls"})';

export const MPFS_TOTAL_FAILED_SAMBA = 'count(up{job=~"mpfs_samba"}) - sum(up{job=~"mpfs_samba"})';
export const MPFS_TOTAL_FAILED_MDS = 'count(up{job=~"mpfs_mds"}) - sum(up{job=~"mpfs_mds"})';
export const MPFS_TOTAL_FAILED_DS = 'count(up{job=~"mpfs_ds"}) - sum(up{job=~"mpfs_ds"})';
export const MPFS_TOTAL_FAILED_LS = 'count(up{job=~"mpfs_ls"}) - sum(up{job=~"mpfs_ls"})';

export const MPFS_TOTAL_INGRESS = 'sum(rate(mpfs_samba_bytes_read_total[5m]))';
export const MPFS_TOTAL_EGRESS = 'sum(rate(mpfs_samba_bytes_written_total[5m]))';

export const MPFS_IOPS_READ = 'sum(rate(mpfs_samba_op_total{op="read"}[5m]))';
export const MPFS_IOPS_WRITE = 'sum(rate(mpfs_samba_op_total{op="write"}[5m]))';

export const MPFS_READ_LATENCY_95 = 'histogram_quantile(0.95, sum(rate(mpfs_samba_op_latency_ms_bucket{op="read"}[5m])) by (le)) / 1000';
export const MPFS_READ_LATENCY_99 = 'histogram_quantile(0.99, sum(rate(mpfs_samba_op_latency_ms_bucket{op="read"}[5m])) by (le)) / 1000';
export const MPFS_READ_LATENCY_100 = 'histogram_quantile(1.00, sum(rate(mpfs_samba_op_latency_ms_bucket{op="read"}[5m])) by (le)) / 1000';
export const MPFS_READ_LATENCY_AVG = 'sum(rate(mpfs_samba_op_latency_ms_sum{op="read"}[5m]))/sum(rate(mpfs_samba_op_latency_ms_count{op="read"}[5m])) / 1000';

export const MPFS_WRITE_LATENCY_95 = 'histogram_quantile(0.95, sum(rate(mpfs_samba_op_latency_ms_bucket{op="write"}[5m])) by (le)) / 1000';
export const MPFS_WRITE_LATENCY_99 = 'histogram_quantile(0.99, sum(rate(mpfs_samba_op_latency_ms_bucket{op="write"}[5m])) by (le)) / 1000';
export const MPFS_WRITE_LATENCY_100 = 'histogram_quantile(1.00, sum(rate(mpfs_samba_op_latency_ms_bucket{op="write"}[5m])) by (le)) / 1000';
export const MPFS_WRITE_LATENCY_AVG = 'sum(rate(mpfs_samba_op_latency_ms_sum{op="write"}[5m]))/sum(rate(mpfs_samba_op_latency_ms_count{op="write"}[5m])) / 1000';

export const MPFS_SYNC_LATENCY_95 = 'histogram_quantile(0.95, sum(rate(mpfs_samba_op_latency_ms_bucket{op="fsync"}[5m])) by (le)) / 1000';
export const MPFS_SYNC_LATENCY_99 = 'histogram_quantile(0.99, sum(rate(mpfs_samba_op_latency_ms_bucket{op="fsync"}[5m])) by (le)) / 1000';
export const MPFS_SYNC_LATENCY_100 = 'histogram_quantile(1.00, sum(rate(mpfs_samba_op_latency_ms_bucket{op="fsync"}[5m])) by (le)) / 1000';
export const MPFS_SYNC_LATENCY_AVG = 'sum(rate(mpfs_samba_op_latency_ms_sum{op="fsync"}[5m]))/sum(rate(mpfs_samba_op_latency_ms_count{op="fsync"}[5m])) / 1000';

export const OVERVIEW_PACK = {
  OVERVIEW_DISK_READ,
  OVERVIEW_DISK_READ_IOPS,
  OVERVIEW_DISK_WRITE,
  OVERVIEW_DISK_WRITE_IOPS,
  OVERVIEW_CS_STATUSES,
  OVERVIEW_MDS_FAILED,
  OVERVIEW_MDS_ONLINE
};

export const NODE_PACK = {
  NODE_CPU_USAGE,
  NODE_MEM_USAGE,
  NODE_DISKS_READ,
  NODE_DISKS_READ_IOPS,
  NODE_DISKS_WRITE,
  NODE_DISKS_WRITE_IOPS,
  NODE_NETWORK_RECEIVE,
  NODE_NETWORK_TRANSMIT
};

export const NODE_INTERFACE_PACK = {
  NODE_INTERFACE_RX,
  NODE_INTERFACE_TX,
  NODE_INTERFACE_RX_PACKAGES,
  NODE_INTERFACE_TX_PACKAGES,
  NODE_INTERFACE_RX_ERRORS,
  NODE_INTERFACE_TX_ERRORS
};

export const NODE_DISK_PACK = {
  NODE_DISK_READ_LATENCY,
  NODE_DISK_WRITE_LATENCY,
  NODE_DISK_READ_BANDWIDTH,
  NODE_DISK_WRITE_BANDWIDTH,
  NODE_DISK_READ_IOPS,
  NODE_DISK_WRITE_IOPS,
};

export const COMPUTE_PACK = {
  COMPUTE_CPU_USAGE,
  COMPUTE_MEM_USAGE,
  COMPUTE_DISK_READ,
  COMPUTE_DISK_WRITE,
  COMPUTE_DISK_READ_IOPS,
  COMPUTE_DISK_WRITE_IOPS,
  COMPUTE_DISK_READ_LATENCY_95,
  COMPUTE_DISK_READ_LATENCY_99,
  COMPUTE_DISK_READ_LATENCY_100,
  COMPUTE_DISK_READ_LATENCY_AVG,
  COMPUTE_DISK_WRITE_LATENCY_95,
  COMPUTE_DISK_WRITE_LATENCY_99,
  COMPUTE_DISK_WRITE_LATENCY_100,
  COMPUTE_DISK_WRITE_LATENCY_AVG,
  COMPUTE_DISK_FLUSH_LATENCY_95,
  COMPUTE_DISK_FLUSH_LATENCY_99,
  COMPUTE_DISK_FLUSH_LATENCY_100,
  COMPUTE_DISK_FLUSH_LATENCY_AVG,
  COMPUTE_NETWORK_RECEIVE,
  COMPUTE_NETWORK_TRANSMIT,
  COMPUTE_NETWORK_RECEIVE_PACKETS,
  COMPUTE_NETWORK_TRANSMIT_PACKETS,
  COMPUTE_NETWORK_RECEIVE_DROPS,
  COMPUTE_NETWORK_TRANSMIT_DROPS
};

export const LOAD_BALANCER_CPU_MEM_PACK = {
  LBAAS_LOAD_BALANCER_CPU,
  LBAAS_LOAD_BALANCER_RAM
};

export const LOAD_BALANCER_PACK = {
  LBAAS_LOAD_BALANCER_REQUEST_ERRORS,
  LBAAS_LOAD_BALANCER_ACTIVE_CONNECTIONS,
  LBAAS_LOAD_BALANCER_NETWORK_RECEIVE,
  LBAAS_LOAD_BALANCER_NETWORK_TRANSMIT
};

export const LOAD_BALANCER_POOL_PACK = {
  NETWORK_RECEIVE: LBAAS_BALANCER_POOL_NETWORK_RECEIVE,
  NETWORK_TRANSMIT: LBAAS_BALANCER_POOL_NETWORK_TRANSMIT,
  ACTIVE_CONNECTIONS: LBAAS_BALANCER_POOL_ACTIVE_CONNECTIONS,
  REQUEST_ERRORS: LBAAS_BALANCER_POOL_REQUEST_ERRORS
};

export const LOAD_BALANCER_POOL_MEMBER_PACK = {
  NETWORK_RECEIVE: LBAAS_BALANCER_POOL_MEMBER_NETWORK_RECEIVE,
  NETWORK_TRANSMIT: LBAAS_BALANCER_POOL_MEMBER_NETWORK_TRANSMIT,
  ACTIVE_CONNECTIONS: LBAAS_BALANCER_POOL_MEMBER_ACTIVE_CONNECTIONS,
  REQUEST_ERRORS: LBAAS_BALANCER_POOL_MEMBER_REQUEST_ERRORS
};

export const S3_PACK = {
  S3_ACC_ONLINE,
  S3_NS_ONLINE,
  S3_OS_ONLINE,
  S3_GW_ONLINE,
  S3_ACC_FAILURE,
  S3_NS_FAILURE,
  S3_OS_FAILURE,
  S3_GW_FAILURE,
  S3_RATE_PUT,
  S3_RATE_GET,
  S3_RATE_LIST,
  S3_RATE_DELETE,
  S3_RATE_FAILURE,
  S3_INGRESS,
  S3_EGRESS,
  S3_PUT_LATENCY_LATENCY_95,
  S3_PUT_LATENCY_LATENCY_99,
  S3_PUT_LATENCY_LATENCY_100,
  S3_PUT_LATENCY_AVG,
  S3_GET_LATENCY_LATENCY_95,
  S3_GET_LATENCY_LATENCY_99,
  S3_GET_LATENCY_LATENCY_100,
  S3_GET_LATENCY_AVG
};

export const ISCSI_PACK = {
  ISCSI_DISK_READ,
  ISCSI_DISK_WRITE,
  ISCSI_DISK_READ_IOPS,
  ISCSI_DISK_WRITE_IOPS,
  ISCSI_DISK_READ_LATENCY_95,
  ISCSI_DISK_READ_LATENCY_99,
  ISCSI_DISK_READ_LATENCY_100,
  ISCSI_DISK_READ_LATENCY_AVG,
  ISCSI_DISK_WRITE_LATENCY_95,
  ISCSI_DISK_WRITE_LATENCY_99,
  ISCSI_DISK_WRITE_LATENCY_100,
  ISCSI_DISK_WRITE_LATENCY_AVG
};

export const S3_NODE_PACK = {
  S3_NODE_CPU_USAGE,
  S3_NODE_MEM_USAGE,
  S3_NODE_SUCCESS_RATE,
  S3_NODE_FAILED_RATE,
  S3_NODE_NETWORK_READ,
  S3_NODE_NETWORK_WRITE,
  S3_NODE_NETWORK_READ_IOPS,
  S3_NODE_NETWORK_WRITE_IOPS,
  S3_NODE_LATENCY_95,
  S3_NODE_LATENCY_99,
  S3_NODE_LATENCY_100,
  S3_NODE_LATENCY_AVG,
  S3_NODE_PUT_LATENCY_LATENCY_95,
  S3_NODE_PUT_LATENCY_LATENCY_99,
  S3_NODE_PUT_LATENCY_LATENCY_100,
  S3_NODE_PUT_LATENCY_AVG,
  S3_NODE_GET_LATENCY_LATENCY_95,
  S3_NODE_GET_LATENCY_LATENCY_99,
  S3_NODE_GET_LATENCY_LATENCY_100,
  S3_NODE_GET_LATENCY_AVG
};

export const ABGW_NODE_PACK = {
  ABGW_NODE_CPU_USAGE,
  ABGW_NODE_MEM_USAGE,
  ABGW_NODE_SUCCESS_RATE,
  ABGW_NODE_FAILED_RATE,
  ABGW_NODE_NETWORK_READ,
  ABGW_NODE_NETWORK_WRITE,
  ABGW_NODE_NETWORK_READ_IOPS,
  ABGW_NODE_NETWORK_WRITE_IOPS,
  ABGW_NODE_LATENCY_AVG,
  ABGW_NODE_LATENCY_95,
  ABGW_NODE_LATENCY_99,
  ABGW_NODE_LATENCY_100
};

export const ABGW_PACK = {
  ABGW_FAILED_NODES,
  ABGW_ONLINE_NODES,
  ABGW_READ,
  ABGW_WRITE,
  ABGW_REPLICA_BACKLOG,
  ABGW_REPLICA_SPEED,
  ABGW_OSTOR_BACKLOG,
  ABGW_OSTOR_SPEED,
  ABGW_LATENCY_95,
  ABGW_LATENCY_99,
  ABGW_LATENCY_100,
  ABGW_LATENCY_AVG,
  ABGW_THROTTLE
};

export const MPFS_PACK = {
  MPFS_TOTAL_SAMBA_ONLINE,
  MPFS_TOTAL_MDS_ONLINE,
  MPFS_TOTAL_DS_ONLINE,
  MPFS_TOTAL_LS_ONLINE,
  MPFS_TOTAL_FAILED_SAMBA,
  MPFS_TOTAL_FAILED_MDS,
  MPFS_TOTAL_FAILED_DS,
  MPFS_TOTAL_FAILED_LS,
  MPFS_TOTAL_INGRESS,
  MPFS_TOTAL_EGRESS,
  MPFS_IOPS_READ,
  MPFS_IOPS_WRITE,
  MPFS_READ_LATENCY_95,
  MPFS_READ_LATENCY_99,
  MPFS_READ_LATENCY_100,
  MPFS_READ_LATENCY_AVG,
  MPFS_WRITE_LATENCY_95,
  MPFS_WRITE_LATENCY_99,
  MPFS_WRITE_LATENCY_100,
  MPFS_WRITE_LATENCY_AVG,
  MPFS_SYNC_LATENCY_95,
  MPFS_SYNC_LATENCY_99,
  MPFS_SYNC_LATENCY_100,
  MPFS_SYNC_LATENCY_AVG
};
